import { useSpring, animated } from '@react-spring/web'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const Home: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style, api] = useSpring(() => ({
		from: {
			rotate: 0,
		},
		config: {
			duration: 800,
		},
		onRest: (_, spring) => spring.set({ rotate: 0 }),
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all(
				api.start({
					to: [{ rotate: 360 }],
				}),
			).catch(console.error)
		}
	}, [animate, api])

	return (
		<animated.span style={style}>
			<svg
				data-name="Ebene 1"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<path d="M347.21 218.62h-24v102.06a20 20 0 01-20 20h-57.69V253A11.5 11.5 0 00234 241.46h-41.53A11.49 11.49 0 00181 253v87.77h-59.48a20 20 0 01-20-20V218.62h-24.1c-15.38 0-22.53-19.09-10.92-29.21L201.39 72a16.67 16.67 0 0121.87 0l134.89 117.41c11.61 10.12 4.46 29.21-10.94 29.21z" />
			</svg>
		</animated.span>
	)
}

export { Home }
